export const palette = {
  common: {
    black: '#212121',
    white: '#fffff',
  },
  primary: {
    light: '#faf2e8',
    main: '#FF9800',
    dark: '#FF9800',
  },
  secondary: {
    light: '#F72D2D',
    main: '#FF1B40',
    dark: '#C91126',
  },
  grey: {
    600: '#878787',
  },
}
